import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ResetComponent } from './components/reset/reset.component';
import { SignupHeaderComponent } from './components/signup-header/signup-header.component';
import { BrMaskDirective } from './directives/br-mask/br-mask.directive';
import { AdminGuardService } from './services/admin-guard.service';
import { AuthGuardService } from './services/auth-guard.service';

const COMPONENTS = [
  BrMaskDirective,
  LoginComponent,
  RegisterComponent,
  ResetComponent,
  SignupHeaderComponent,
]

@NgModule({
  providers: [
    AuthGuardService,
    AdminGuardService,
  ],
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      { path: '', component: LoginComponent },
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent, },
      { path: 'password/reset/:token/:email', component: ResetComponent },
      { path: '**', redirectTo: 'login' }
    ]),
  ],
  declarations: COMPONENTS,
  exports: [],
})
export class AuthModule { }
